'use client';

import { cn } from '@/lib/utils';
import { PathEnum } from '@/types/enums';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import Button from '../ui/Button';
import H1 from '../ui/H1';
import Link from '../ui/Link';

export default function ParallaxHero({
    title,
    imageSrc,
    hasGetOffer,
    imageClassNames,
}: {
    title?: string;
    imageSrc: string;
    hasGetOffer?: boolean;
    imageClassNames?: string;
}) {
    const t = useTranslations('Buttons');

    const [scrollY, setScrollY] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            setScrollY(window.scrollY);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const parallaxStyle = {
        transform: `translateY(-${scrollY * 0.2}px)`,
    };

    const imageStyles = cn(
        'w-full h-1/2 lg:h-full fixed top-0 left-0 z-negative brightness-25',
        imageClassNames,
    );

    return (
        <section className="w-full h-[55vh] max-lg:h-[30vh] relative overflow-hidden">
            <div className={imageStyles} style={parallaxStyle}>
                <Image
                    className="object-cover max-lg:object-[30%]"
                    src={imageSrc}
                    fill
                    alt="hero"
                />
            </div>
            {title && (
                <div className="h-full w-full container mx-auto flex flex-col text-center justify-center items-center max-lg:px-4 px-0 max-w-[1084px] text-white relative z-1">
                    <H1>{title}</H1>
                    {hasGetOffer && (
                        <Link className="get-offer-trigger w-fit mt-[2%]" href={PathEnum.Contact}>
                            <Button title={t('getOffer')} withArrow />
                        </Link>
                    )}
                </div>
            )}
        </section>
    );
}
